import React from 'react';
import { XCircleIcon } from 'lucide-react';
import { problems } from '../data/landing';
export function ProblemSection() {
  return <section className="bg-night px-5 py-16" data-id="element-164" data-mp="2ltwahol6icuz">
      <div className="mx-auto max-w-4xl text-center" data-id="element-165" data-mp="30gxu3xcr9fmr">
        <p className="text-xs font-bold uppercase tracking-[.2em] text-gold" data-id="element-166" data-mp="30isf1bo117qu">
          The coaching reality
        </p>
        <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-167" data-mp="2voek1ada12mp">
          If you coach tennis, you are probably dealing with at least one of
          these problems.
        </h2>
        <div className="mt-10 grid gap-3 text-left sm:grid-cols-2" data-id="element-168" data-mp="3jftll0x8bfww">
          {problems.map(problem => <div key={problem} className="flex gap-3 border border-white/10 bg-night-card p-4" data-id="element-169" data-mp="3egh3ethayx0n">
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" data-id="element-170" data-mp="1p2kknxir12q9" />
              <p className="text-sm font-semibold leading-snug text-white" data-id="element-171" data-mp="1k3zm02j5ar3x">
                {problem}
              </p>
            </div>)}
        </div>
        <p className="mt-10 font-display text-3xl font-bold uppercase leading-none text-gold sm:text-4xl" data-id="element-172" data-mp="oc7xjguomdit">
          How many more sessions do you want to keep improvising?
        </p>
      </div>
    </section>;
}